/* eslint-disable import/prefer-default-export */
import React from 'react'

const EllipseIcon = center => (
  <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg" style={center && { verticalAlign: 'middle', paddingRight: '2px' }}>
    <path d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5Z" fill="#F6F6F6" />
  </svg>
)

export default EllipseIcon
